import React from "react";

export default function Background({ variant = "default", aurora = false }) {
  return (
    <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden" aria-hidden="true" data-testid="background-effects">
      <div className="mt-orb mt-keep-anim" style={{ width:620, height:620, background:"radial-gradient(circle, rgba(192,160,255,0.5), transparent 60%)", opacity:0.07, top:"-10%", left:"-12%", animation:"mt-orb-drift 28s ease-in-out infinite" }} />
      <div className="mt-orb mt-keep-anim" style={{ width:540, height:540, background:"radial-gradient(circle, rgba(0,170,255,0.55), transparent 60%)", opacity:0.06, bottom:"-15%", right:"-10%", animation:"mt-orb-drift 36s ease-in-out infinite reverse" }} />
      {aurora && (
        <>
          <div className="mt-aurora mt-keep-anim" style={{ top:"20%" }} />
          <div className="mt-aurora mt-keep-anim" style={{ top:"65%", animationDelay:"4s" }} />
        </>
      )}
    </div>
  );
}
